export default "__VITE_ASSET__CMVQsWWE__"